import React from 'react'
import './Carousel.css'
import Slider from "react-slick";

function Carousel() {

    const settings = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        speed: 4000,
        cssEase: "linear",
      };

  return (
    <>
        <Slider className='slider' {...settings}>
          <div>
            <div className='slider-item'></div>
          </div>
          <div>
            <div className='slider-item'></div>
          </div>
          <div>
            <div className='slider-item'></div>
          </div>
          <div>
            <div className='slider-item'></div>
          </div>
          <div>
            <div className='slider-item'></div>
          </div>
          <div>
            <div className='slider-item'></div>
          </div>
          <div>
            <div className='slider-item'></div>
          </div>
          <div>
            <div className='slider-item'></div>
          </div>
          <div>
            <div className='slider-item'></div>
          </div>
        </Slider>
      </>
  )
}

export default Carousel